export default __webpack_public_path__ + "static/media/kalechips@2x.481f4527.jpg";